import { PREFIX_COVERHOLDER } from "@/api/Model/ProductOwnerModel";
import AbstractWording from "../Wording";

class Wording extends AbstractWording {
  static getResourceEndpoint() {
    return PREFIX_COVERHOLDER + '/product-wordings-ipr';
  }
}

export default Wording;
